import React from 'react';
import { Channels } from '../common/channelsEnum';
import { log } from './LogStreamTable';
import { Typography } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import JsonDisplay from './JsonDisplay';

const { Text } = Typography;

const DeliveredLogDetails = ({ log }: { log: log }): JSX.Element => {
  if (log.message.channels?.[0] === Channels.EMAIL) {
    return (
      <>
        <Paragraph type="success">
          {typeof log.message.message === 'object' &&
            log.message.message.delivery?.recipients?.[0]}
        </Paragraph>
        <Paragraph type="secondary">
          Received Delivery Confirmation from{' '}
        </Paragraph>
        <JsonDisplay json={log.message.message as Record<string, unknown>} />
      </>
    );
  }

  if (log.message.channels?.[0] === Channels.SMS) {
    return (
      <>
        <Text type="secondary">Received Delivery Confirmation:</Text>
        <JsonDisplay
          json={JSON.stringify(
            {
              ...log.message,
              AccountSid: undefined,
              MessageSid: undefined,
              notificationId: undefined,
              envId: undefined,
              ApiVersion: undefined,
              channels: undefined
            },
            null,
            2
          )}
        />
      </>
    );
  }

  if (log.message.channels?.[0] === Channels.CALL) {
    return (
      <>
        <Text type="secondary">Call Confirmation:</Text>
        <JsonDisplay
          json={JSON.stringify(
            {
              ...log.message,
              AccountSid: undefined,
              MessageSid: undefined,
              notificationId: undefined,
              envId: undefined,
              ApiVersion: undefined,
              channels: undefined
            },
            null,
            2
          )}
        />
      </>
    );
  }

  if (log.message.channels?.[0] === Channels.INAPP_WEB) {
    return (
      <>
        <Text type="secondary">
          The in-app notification has successfully been stored in the user's
          inbox.
        </Text>
      </>
    );
  }

  if (log.message.channels?.[0] === Channels.PUSH) {
    return (
      <>
        <Text type="secondary">
          The mobile push notification has been sent to the user's mobile
          network.
        </Text>
      </>
    );
  }

  if (log.message.channels?.[0] === Channels.WEB_PUSH) {
    return (
      <>
        <Text type="secondary">
          The web push notification has been sent to the user's browser.
        </Text>
      </>
    );
  }

  return <></>;
};
export default DeliveredLogDetails;
